import styled from "styled-components"

export default styled.div`
  & > span {
    font-weight: 600;
  }
`
